export const getAirportIcon = (flightNo?: string) => {
  if (!flightNo) return "";
  if (flightNo.startsWith("IW")) {
    return require("@/app/ui/assets/svg/flight-IW-wings-circle.svg");
  }
  if (flightNo.startsWith("ID")) {
    return require("@/app/ui/assets/svg/flight-ID-batik-circle.svg");
  }
  if (flightNo.startsWith("IU")) {
    return require("@/app/ui/assets/svg/flight-IU-super-airjet-circle.svg");
  }
  return require("@/app/ui/assets/svg/flight-JT-lion-circle.svg");
};
